import { Shark, SmartModel } from "shark-mvc";
// import NousCoreModel from "./NousCoreModel";

class ContentPackPage extends SmartModel {
	body = "";
	contents = {
		images: [],
		texts: [],
	};
	pageIndex = -1;
	title = "";
	

	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	addContent (content) {
		switch (content.type) {
			case "image":
				this.contents.images.push(content);
				break;
			case "text":
				this.contents.texts.push(content);
				break;
		}
	}

	deleteContent (data) {
		switch (data.type) {
			case "image": {
				const indexToRemove = this.contents.images.findIndex(item => item.guid === data.guid);

				if (indexToRemove > -1) {
					this.contents.images.splice(indexToRemove, 1);
				}
				break;
			}
			case "text": {
				const indexToRemove = this.contents.texts.findIndex(item => item.guid === data.guid);

				if (indexToRemove > -1) {
					this.contents.texts.splice(indexToRemove, 1);
				}
				break;
			}
		}
	}

	// import (data, options) {
	// 	super.import(data, options);
	// }
}

Shark.registerModel("ContentPackPage", ContentPackPage);

export default ContentPackPage;